import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Send } from "lucide-react";
import TextArea from "antd/es/input/TextArea";
import AIButton from "components/ai/aibutton";
import IndexModal from "components/modal";
import Card from "components/card";
import Button  from "components/button";
import { 
    doAskCopilot
} from "../../redux/copilot/copilotState";
import CopilotResponseView from "./CopilotResponseView";

const CopilotEli = ({doGenerateRequest, responseData, requesting}) => {
    const [showCopilotEli, setShowCopilotEli] = useState(false);
    const [showResponseBox, setShowResponseBox] = useState(false);
    const [chatMessage, setChatMessage] = useState('');
    const [generateLabel, setGenerateLabel] = useState('Generate with Eli');
    const onClickGenerate = () => {
        setGenerateLabel('Thinking....');
        doGenerateRequest({field: 'general_accountant', message: chatMessage});
    }

    useEffect(() => {
        if(responseData){
            setShowResponseBox(true);
            setGenerateLabel('Generate with Eli');
        }
    }, [responseData]);

    return (
        <>
            <AIButton label="Finance Eli" size="large" calllHandler={() => setShowCopilotEli(true)}/>
            <IndexModal
                open={showCopilotEli}
                onClose={() => setShowCopilotEli(false)}
                width={900}
                closable={false}
            >
                <div className="flex flex-col gap-4">
                    <Card extra={`${showResponseBox ? '' : 'hidden'} p-4`}> 
                        <div className="max-h-[360px] overflow-auto border rounded p-2">
                            <CopilotResponseView message={responseData?.message}/>
                        </div>
                        
                    </Card>
                    <Card extra="p-2">
                        <AIButton size="large" label="How can I help you?"/>
                        <div className="pt-4 flex-1">
                            <TextArea
                                className="input-field"
                                placeholder="Enter detailed instruction to generate" 
                                rows={2}
                                autoSize
                                onChange={(e) => setChatMessage(e.target.value)}
                            />
                            <Button 
                                className="mt-4 w-full flex items-center justify-center gap-2 border border-gray-300 rounded-lg py-2 text-[16px] text-white font-medium bg-gradient-to-r from-blue-500 via-cyan-500 to-teal-500 hover:bg-gray-50 transition"
                                onClick={onClickGenerate}>
                                <Send className="w-3 h-3" /> 
                                <span>{ generateLabel }</span>
                            </Button>
                        </div>
                    </Card>
                </div>
            </IndexModal>
        </>
    );
};

const mapStateToProps = (state) => ({
    responseData: state.copilot.copilotData?.results,
    requesting: state.copilot.copilotData?.requesting,
	success: state.copilot.copilotData?.succcess,
  	error: state.copilot.copilotData?.error,
});

const mapDispatchToProps = (dispatch) => ({
    doGenerateRequest: (data) => dispatch(doAskCopilot(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CopilotEli);
